
/* injects from baggage-loader */
var Template = require('./template.js');

/**
 * Renders the event <div> ( name, price, arrows when price changes)
 * on click event is added/removed from betslip or bet is made if betslip is in quick bet mode.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import OddConverter from "@common/helpers/oddConverter";
import { GetOddsFormat } from "../../../helpers/selectors";
import { createBetslipEventObject, makeQuickBet, toggleEvent, addToSwarmDataBetslip, toggleHorseEvent } from "../../../helpers/sport/betslip";
import PropTypes from 'prop-types';
import { handicapBaseFormat } from "../../../helpers/filters";
import Config from "../../../config/main";
import { createSelector } from "reselect";
import { typeIsForCastOrTriCast, typesMap, isInclude } from '../../../middleware/betslipUpdateHandler';
import { BoostedTypes } from './boostedEnum';

class Event extends Component {
    constructor (props) {
        super(props);
        this.makeQuickBet = this.makeQuickBet.bind(this);
        this.toggle = this.toggle.bind(this);
        this.isEventInBetslip = this.isEventInBetslip.bind(this);
    }
    /**
     * @name makeQuickBet
     * @description helper function for preparing bets object
     * @returns {undefined}
     * */
    makeQuickBet (e) {
        e.stopPropogation()

        let { dispatch, event } = this.props,
            bet = createBetslipEventObject(this.props.game, this.props.market, this.props.event);

        return dispatch(makeQuickBet(event.id, bet));
    }

    /**
     * @name toggle
     * @description toggle function for adding and removing events from betSlip
     * @returns {undefined}
     * */
    toggle (e) {
        e.stopPropagation()

        if (this.props.isDisable) {
            return;
        }
        if (this.lastClickedAt && this.lastClickedAt >= Date.now() - 500) {
            return;
        }
        this.lastClickedAt = Date.now();
        let { dispatch, game, market, event, sportType, hoursType, boostedOdds, gameType } = this.props;

        const boostType = boostedOdds?.[event?.id]?.BoostType

        const boostedShowTypes = [BoostedTypes.Both, gameType === "prematch" ? BoostedTypes.Prematch : BoostedTypes.Live]

        let isBoosted = boostedShowTypes.includes(boostType)

        if (this.props.sportType === 'HORSE') {
            dispatch(toggleHorseEvent(hoursType, game.id, event.id));
        }
        if (event) {
            dispatch(toggleEvent(game, Array.isArray(market) ? market[0] : market, event, sportType, event.id, isBoosted));
        }
    }
    /**
     * @name isEventInBetslip
     * @description check if event in betSlip
     * @returns {undefined}
     * */
    isEventInBetslip () {
        return !this.props.quickBet && this.props.event && this.props.isSelected;
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
    componentDidMount () {
        window.preventDrags();
    }
}

Event.propTypes = {
    event: PropTypes.object,
    game: PropTypes.object,
    market: PropTypes.object,
    name: PropTypes.string,
    sportType: PropTypes.string,
    hoursType: PropTypes.string,
    isDisable: PropTypes.bool
};
Event.defaultProps = {
    sportType: 'odd',
    hoursType: ''
};
function mapStateToProps () {
    return createSelector(
        [
            state => state.betslip.quickBet,
            GetOddsFormat,
            (state, ownParams) => {                
                const id = (ownParams.event?.id?.toString?.() || '');
                const { oddType } = state.betslip.events[id] || {};
                if (ownParams.sportType === 'HORSE' && oddType === 'HORSE') {
                    if (state.betslip.events[id] && state.betslip.horseEvents[id]) {
                        return ownParams?.hoursType === state.betslip.horseEvents[id].type;
                    }
                    return false;
                }
                return !!state.betslip.events[id];
            },
            (state, ownParams) => {
                const id = (ownParams.event?.id?.toString?.() || '');
                if (ownParams.sportType !== "HORSE" || ![40, 43].includes(state.betslip.type)) return false;
                if (!ownParams.hoursType || typesMap[typeIsForCastOrTriCast(ownParams.hoursType)] !== state.betslip.type) return false;
                const hoursTypesArray = Object.keys(state.betslip.horseEvents).map(item => state.betslip.horseEvents[item].type);
                let result = true;
                if (hoursTypesArray.some(item => !isInclude(item)) !== isInclude(ownParams.hoursType)) {
                    result = false;
                }
                if (hoursTypesArray.every(item => isInclude(item)) && hoursTypesArray.includes(ownParams.hoursType)) {
                    result = true;
                }
                if (state.betslip.events[id] && state.betslip.horseEvents[id]) {
                    result = ownParams?.hoursType !== state.betslip.horseEvents[id].type;
                }

                return result;
            }
        ],
        // isDisable inplemented for tricast or forecast
        (quickBet, oddsFormat, isSelected, isDisable) => ({ oddsFormat, isSelected, quickBet, isDisable })
    );
}

export default connect(mapStateToProps)(Event);